import React from "react";
import { Link, useParams } from "react-router-dom";
import Blog1 from "./Blog1";
import Blog2 from "./Blog2";
import "./Blogs.css";

const BlogDetail = () => {
  const { slug } = useParams();

  switch (slug) {
    case "varfor-ditt-foretag-behover":
      return <Blog1 />;
    case "thas-redovisnings-guide-to":
      return <Blog2 />;
    default:
      return (
        <section className="thas-blog-missing site-container" aria-labelledby="missing-article-heading">
          <p className="site-eyebrow">KUNSKAP & GUIDER</p>
          <h1 id="missing-article-heading">Artikeln kunde inte hittas</h1>
          <p>Länken kan vara felaktig eller artikeln kan ha flyttats. Du hittar våra aktuella guider på bloggsidan.</p>
          <Link to="/blogg" className="site-button">Se alla guider <span aria-hidden="true">↗</span></Link>
        </section>
      );
  }
};

export default BlogDetail;